export const redirectToMaps = addressString => {
  window.open(
    `https://www.google.com/maps/search/${encodeURIComponent(addressString)}`
  );
};
